/*
 * @Author: huangzq
 * @Date: 2020-03-17 16:24:19
 * @Last Modified by: huangzq
 * @Last Modified time: 2020-04-02 21:25:03
 * @Desc: pdf导入时的进度弹窗
*/
<template>
  <mk-dialog
    :visible="visible"
    :show-close="uploadFinished"
    :close-on-click-modal="uploadFinished"
    :modal-append-to-body="true"
    :append-to-body="true"
    :title="title"
    width="402px"
    class="progress-dialog"
    @close="onClose"
  >
    <div class="dialog-content">
      <!-- 上传完成 -->
      <template v-if="uploadFinished">
        <upload-finished
          :show-num="false"
          success-text="导入成功"
          fail-text="导入失败"
        />
      </template>

      <!-- 上传中 -->
      <progress-loading v-else />

      <!-- 上传进度条展示 -->
      <div class="progress-wrapper">
        <div
          class="progress-item"
        >
          <mk-progress
            :percentage="progress"
            :stroke-width="8"
            :color="statusMap[status]"
          />
        </div>
      </div>
    </div>
  </mk-dialog>
</template>

<script>

import ProgressLoading from './file-upload-progress/progress-loading'
import UploadFinished from './file-upload-progress/upload-finished'

export default {
  name: 'PdfProgressDialog',
  components: {
    ProgressLoading,
    UploadFinished
  },
  props: {
    title: {
      type: String,
      default: '导入弹窗'
    },
    visible: {
      type: Boolean,
      default: false
    },
    // 是否上传结束
    uploadFinished: {
      type: Boolean,
      default: false
    },
    progress: {
      type: Number,
      default: 100
    },
    status: {
      type: String,
      default: 'success'
    }
  },
  data () {
    return {
      // 状态颜色map
      statusMap: {
        progress: '#1890FF',
        success: '#52C41A',
        fail: '#FF5500'
      }
    }
  },
  methods: {
    /**
     * * 弹窗关闭事件
     */
    onClose () {
      this.$emit('update:visible', false)
      this.$emit('on-close')
    }

  }
}
</script>

<style lang='scss' scoped>
.progress-dialog {
  display: flex;
  align-items: center;
  justify-content: center;

  & /deep/ .el-dialog {
    margin: 0 !important;

    .dialog-content {
      .progress-wrapper {
        margin-top: 23px;

        .progress-item {
          margin-bottom: 10px;
          color: #8c8c8c;
          font-size: 14px;

          .file-name {
            line-height: 22px;

            .icon-mk-gongzuotai-fujian {
              margin-right: 8px;
              font-size: 14px;
            }
          }

          .mk-progress {
            .el-progress__text {
              color: rgba(0, 0, 0, 0.45);
              font-size: 14px !important;
              margin-left: 12px;
            }
          }
        }
      }
    }
  }
}
</style>
